<template>
	<widget title="Messages" 
		icon="fa-envelope" 
		:max-height="maxHeight" 
		header-button="fa-external-link-alt"
		v-on:headerButtonClick="$router.push('/messages')">
		
		<message-thread-list 
			side-margins="-8px"
			:job-id="jobId"
			:service-id="serviceId"
			:store-threads-locally="true">		
		</message-thread-list>
	</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import MessageThreadList from "@/components/super_components/MessageThreadList"

export default {
	name: "MessagesWidget",
	components: {
		Widget,
		MessageThreadList
	},
	props: ["serviceId","jobId","maxHeight"]
}
</script>